export default "__VITE_ASSET__BdV0Oimv__"